import { WebsiteHeaderPhotoSchema_NoPhoto_v1_1_1 } from '@apps/guest/websiteHeader';

export const NO_PHOTO_v1_1_1: WebsiteHeaderPhotoSchema_NoPhoto_v1_1_1 = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/noPhoto-v1_1_1.json',
  presentationLayout: 'noPhoto',
  photos: undefined,
};
